import {FC} from 'react'
import {Link} from 'react-router-dom'
import {dateFormat} from 'libs/formatter'
import {AlertType} from './query'
import {List, ListHeader, ListItem, ListArrow, AlertLink, Indicator, AlertDate, StaffCode} from './List'
import styles from './CustomAlerts.scss'

const MAX_DISPLAY_COUNT = 3
const toColor = (int: number): string => (+int ? `#${(+int).toString(16).padStart(6, '0')}` : '#333333')

interface CustomAlertsProps {
  employeeAlerts: AlertType[]
}

export const CustomAlerts: FC<CustomAlertsProps> = ({employeeAlerts}) => {
  if (employeeAlerts.length === 0) {
    return null
  }

  return (
    <div>
      {employeeAlerts.map((alertType) => {
        return (
          <div key={alertType.id}>
            <ListHeader>
              {alertType.name}
              <Link to={`/alerts?alert_type_id=${alertType.id}`} className={styles.alertNumber}>
                （<span className={styles.notParentheses}>{alertType.employeeAlerts.length}件</span>）
              </Link>
            </ListHeader>
            <List>
              {alertType.employeeAlerts.slice(0, MAX_DISPLAY_COUNT).map((employeeAlert) => (
                <ListItem key={employeeAlert.id}>
                  <AlertLink to={`/employees/${employeeAlert.employee.id}`}>
                    <Indicator color={toColor(alertType.color)} />
                    <AlertDate>{dateFormat(employeeAlert.alertStart, 'YYYY年MM月DD日')}</AlertDate>
                    {employeeAlert.employee.staffCode && <StaffCode>{employeeAlert.employee.staffCode}</StaffCode>}
                    <span>{employeeAlert.employee.displayFullName}</span>
                    <ListArrow />
                  </AlertLink>
                </ListItem>
              ))}
            </List>
          </div>
        )
      })}
    </div>
  )
}
